/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskPriorityEnum } from './taskPriorityEnum';
import { TaskStatusEnum } from './taskStatusEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskWrite { 
    readonly id: number;
    subject: number;
    title?: string;
    details?: string;
    status: TaskStatusEnum;
    priority: TaskPriorityEnum;
    patient?: string | null;
    appointment?: number | null;
    assignedToUser?: number | null;
    assignedToTeam?: number | null;
    dueDate?: string | null;
    readonly completedBy: number | null;
    readonly completedAt: string | null;
    readonly createdAt: string | null;
}
export namespace TaskWrite {
}

export const TaskWrite_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskWrite_subject_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskWrite_title_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const TaskWrite_details_Validators: ValidatorFn[] =
    [ ];

export const TaskWrite_status_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskWrite_priority_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskWrite_patient_Validators: ValidatorFn[] =
    [ ];

export const TaskWrite_appointment_Validators: ValidatorFn[] =
    [ ];

export const TaskWrite_assignedToUser_Validators: ValidatorFn[] =
    [ ];

export const TaskWrite_assignedToTeam_Validators: ValidatorFn[] =
    [ ];

export const TaskWrite_dueDate_Validators: ValidatorFn[] =
    [ ];

export const TaskWrite_completedBy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskWrite_completedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskWrite_createdAt_Validators: ValidatorFn[] =
    [  Validators.required, ];


